<ion-app>
  <ng-container *ngIf="appCoreService.isAppReady$ | async; else elseTemplate">
    <ion-split-pane contentId="main-content" when="false">
      <ion-menu menuId="first" contentId="main-content" type="push" side="end">
        <div class="menu-content flex h-full flex-col p-6">
          <div class="flex flex-row items-center justify-end">
            <button class="close-button" (click)="closeMenu()">
              <ion-icon src="../assets/icon/cross.svg"></ion-icon>
            </button>
          </div>

          <div class="list flex flex-col">
            <div class="list-options flex flex-col">
              <ion-menu-toggle menu="first" auto-hide="false">
                <div routerLink="/" class="menu-option">
                  <ion-icon src="../assets/icon/printer.svg"></ion-icon>
                  <span translate>Imprimir</span>
                </div>
              </ion-menu-toggle>

              <ion-menu-toggle menu="first" auto-hide="false">
                <div (click)="toStationery()" class="menu-option">
                  <ion-icon src="../assets/icon/stationary.svg"></ion-icon>
                  <span>Papelería</span>
                </div>
              </ion-menu-toggle>

              <ion-menu-toggle menu="first" auto-hide="false">
                <div routerLink="/papeleria/catalogo/libreta-personalizada" class="menu-option">
                  <ion-icon icon="/assets/icon/libreta-personalizada.svg"></ion-icon>
                  <span>Libretas personalizadas</span>
                </div>
              </ion-menu-toggle>

              <ion-menu-toggle menu="first" auto-hide="false">
                <a href="https://copyfly.es/embajadores">
                  <div class="menu-option">
                    <ion-icon src="../assets/icon/embajadores.svg"></ion-icon>
                    <span translate>Embajadores</span>
                  </div>
                </a>
              </ion-menu-toggle>

              <ion-menu-toggle menu="first" auto-hide="false">
                <a href="https://copyfly.es/imprimir-online-business">
                  <div class="menu-option">
                    <ion-icon src="../assets/icon/bussines.svg"></ion-icon>
                    <span>Business</span>
                  </div>
                </a>
              </ion-menu-toggle>

              <ng-container *ngIf="!userService.userG?.isAnonymous">
                <ion-menu-toggle menu="first" auto-hide="false">
                  <div routerLink="/account" class="menu-option">
                    <ng-container *ngIf="!userService.userG?.isAnonymous; else elseTemplate">
                      <ion-avatar class="avatar">
                        <img
                          src="{{
                            userService.userG?.photoURL
                              ? userService.userG?.photoURL
                              : '/assets/images/blank-profile.png'
                          }}"
                        />
                      </ion-avatar>
                    </ng-container>
                    <ng-template #elseTemplate>
                      <img
                        [src]="'../../assets/images/logo/logo-blanco.svg'"
                        style="width: 200px; height: auto; margin-top: 20px"
                      />
                    </ng-template>
                    <span>Mi cuenta</span>
                  </div>
                </ion-menu-toggle>
              </ng-container>

              <ion-menu-toggle menu="first" auto-hide="false">
                <a href="https://copyfly.es/imprimir-online-business">
                  <div class="menu-option">
                    <ion-icon src="../assets/icon/faqs.svg"></ion-icon>
                    <span>Preguntas frecuentes</span>
                  </div>
                </a>
              </ion-menu-toggle>

              <div
                class="loginSection flex flex-row items-center justify-center"
                *ngIf="userService.userG?.isAnonymous"
              >
                <ion-menu-toggle menu="first" auto-hide="false" routerLink="/auth/login">
                  <ion-button fill="clear">Inicia sesión</ion-button>
                </ion-menu-toggle>
                <ion-menu-toggle menu="first" auto-hide="false" routerLink="/auth/signup">
                  <ion-button fill="clear">o regístrate</ion-button>
                </ion-menu-toggle>
              </div>
            </div>

            <hr />

            <div class="link-container flex flex-col gap-2.5">
              <div>
                <a href="https://copyfly.es/privacidad/" target="_blank"> Políticas de privacidad </a>
              </div>
              <div>
                <a href="https://copyfly.es/terminos-de-servicio/" target="_blank"> Términos de servicio </a>
              </div>
            </div>
          </div>
        </div>
      </ion-menu>

      <ion-router-outlet id="main-content">
        <script
          type="text/javascript"
          charset="UTF-8"
          data-cookiescriptreport="report"
          src="//report.cookie-script.com/r/12646ef1e2c6919ecef016e8621c9320.js"
        ></script>
      </ion-router-outlet>
    </ion-split-pane>

    <ion-menu
      menuId="cart-preview"
      contentId="main-content"
      type="overlay"
      side="end"
      class="cart-preview"
      swipe-gesture="false"
    >
      <app-cart-preview class="h-full w-full"></app-cart-preview>
    </ion-menu>

    <ion-menu
      menuId="account-menu"
      contentId="main-content"
      type="overlay"
      side="end"
      class="account-menu"
      swipe-gesture="false"
    >
      <app-account-menu [mobileMenu]="true" class="h-full"></app-account-menu>
    </ion-menu>

    <ion-menu
      menuId="faqs-menu"
      contentId="main-content"
      type="overlay"
      side="end"
      class="faqs-menu"
      swipe-gesture="false"
    >
      <app-faq-sidebar class="h-full"></app-faq-sidebar>
    </ion-menu>

    <app-whatsapp-fab></app-whatsapp-fab>
  </ng-container>

  <ng-template #elseTemplate>
    <ng-lottie class="loaderApp" [options]="loaderAnimationOptions"></ng-lottie>
  </ng-template>
  <div id="privacy-policy-btn">
    <a href="https://copyfly.es/privacidad/" target="_blank" rel="noopener">
      <button>POLÍTICA DE PRIVACIDAD</button>
    </a>
  </div>
</ion-app>

<!-- warning: keep this here just for ion-alert module to be preloaded -->
<ion-alert></ion-alert>
